export const TIP_OPTIONS = [
  "Rad",
  "Teren",
  "Noćni",
  "Praznik radni",
  "Praznik neradni",
  "Godišnji odmor",
  "Bolovanje <42",
  "Bolovanje >42",
  "Plaćeno odsustvo",
  "Neplaćeno odsustvo",
  "Sedmični odmor",
];

export const TIME_TIPS = ["Rad", "Teren", "Noćni", "Praznik radni"];

export const REKAP_COLS = [
  { key: "redovan", label: "Redovan rad" },
  { key: "teren", label: "Rad na terenu" },
  { key: "nocni", label: "Noćni rad" },
  { key: "prekovremeni", label: "Prekovremeni" },
  { key: "godisnji", label: "Godišnji odmor" },
  { key: "bol42m", label: "Bolovanje <42" },
  { key: "bol42v", label: "Bolovanje >42" },
  { key: "praznik_n", label: "Praznik neradni" },
  { key: "praznik_r", label: "Praznik radni" },
  { key: "placeno", label: "Plaćeno odsustvo" },
  { key: "neplaceno", label: "Neplaćeno odsustvo" },
  { key: "topli", label: "Dana topli obrok", int: true },
];

const WD = ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"];

export function curMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function monthMeta(month) {
  const [y, m] = month.split("-").map(Number);
  const days = new Date(y, m, 0).getDate();
  const list = [];
  for (let d = 1; d <= days; d++) {
    const date = new Date(y, m - 1, d);
    const dow = date.getDay();
    list.push({
      day: d,
      date: `${month}-${String(d).padStart(2, "0")}`,
      weekday: WD[dow],
      weekend: dow === 0 || dow === 6,
    });
  }
  return list;
}

export function workedHours(d) {
  try {
    const [sh, sm] = String(d.start || "").split(":").map(Number);
    const [eh, em] = String(d.end || "").split(":").map(Number);
    if ([sh, sm, eh, em].some((x) => isNaN(x))) return 0;
    const o = Number(d.odmor) || 0;
    const h = (eh * 60 + em - (sh * 60 + sm)) / 60 - o;
    return Math.max(0, Math.round(h * 100) / 100);
  } catch {
    return 0;
  }
}

export function categorize(d) {
  const tip = (d.tip || "").trim();
  const worked = workedHours(d);
  const ot = Number(d.overtime) || 0;
  const res = {
    redovan: 0, teren: 0, nocni: 0, prekovremeni: ot, godisnji: 0, bol42m: 0,
    bol42v: 0, praznik_n: 0, praznik_r: 0, placeno: 0, neplaceno: 0, sedmicni: 0,
  };
  const timeMap = { Rad: "redovan", Teren: "teren", "Noćni": "nocni", "Praznik radni": "praznik_r" };
  if (timeMap[tip]) res[timeMap[tip]] = worked;
  else if (tip === "Godišnji odmor") res.godisnji = 8;
  else if (tip === "Bolovanje <42") res.bol42m = 8;
  else if (tip === "Bolovanje >42") res.bol42v = 8;
  else if (tip === "Praznik neradni") res.praznik_n = 8;
  else if (tip === "Plaćeno odsustvo") res.placeno = 8;
  else if (tip === "Neplaćeno odsustvo") res.neplaceno = 8;
  else if (tip === "Sedmični odmor") res.sedmicni = 1;
  res._worked_day = res.redovan + res.teren + res.nocni + res.praznik_r > 0 ? 1 : 0;
  res._total_hours = Math.round((res.redovan + res.teren + res.nocni + res.praznik_r + res.prekovremeni) * 100) / 100;
  return res;
}

export function formatH(v) {
  return Number(v || 0).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
